import { createAsyncAction } from 'typesafe-actions';

import { HomeActionType } from './actionTypes';

export const getDemandHomeAction = createAsyncAction(
  HomeActionType.GET_DEMAND_HOME_REQUEST,
  HomeActionType.GET_DEMAND_HOME_SUCCESS,
  HomeActionType.GET_DEMAND_HOME_FAILURE
)<undefined, undefined, undefined>();

export const getSupplyHomeAction = createAsyncAction(
  HomeActionType.GET_SUPPLY_HOME_REQUEST,
  HomeActionType.GET_SUPPLY_HOME_SUCCESS,
  HomeActionType.GET_SUPPLY_HOME_FAILURE
)<undefined, undefined, undefined>();
